import RecentActivity from "./recent-activity";

export default RecentActivity;
